import { render, staticRenderFns } from "./StickyPDPNavigation.vue?vue&type=template&id=1fc94580&scoped=true&"
import script from "./StickyPDPNavigation.vue?vue&type=script&lang=ts&"
export * from "./StickyPDPNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./StickyPDPNavigation.vue?vue&type=style&index=0&id=1fc94580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc94580",
  null
  
)

export default component.exports